import { Delete, Edit, Done, Tune } from "@material-ui/icons";
import React, { useState } from "react";
import IncidentType from "../../../types/IncidentType";
import { formatTime } from "../utils/formatTime";
import styled, { css } from 'styled-components';
import {
  Button,
  FormControl,
  IconButton,
  InputLabel,
  Select,
  Tooltip,
} from "@material-ui/core";
import LabelVideoStore from "store/labelVideoStore";
import { inject, observer } from "mobx-react";
import IconIncident from "./iconIncident";
import { theme } from "../progressbar/theme";
import AlertDialog from "../../common/AlertDialog";

const TimeDisplay = ({ label, frame, time, fps }: { label: string, frame: number | null, time: number | null, fps: number }) => (
  <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
    <div style={{ color: "#555", marginRight: "3px", width: "55px" }}>{label} :</div>
    <div style={{ fontWeight: "bold", width: "85px" }} >{time || frame !== null ? formatTime(frame || 0, fps) : "-"}</div>
    {frame !== null && (<div style={{ color: "#555", fontStyle: "italic" }}>(frame {frame})</div>)}
  </div>
);

type Props = {
  incident: IncidentType;
  labelVideoStore?: LabelVideoStore;
  onFinish: any
};

const IncidentItem = ({ incident, labelVideoStore, onFinish }: Props) => {
  const color = incident.class?.color || theme.colors.background;
  const selected = labelVideoStore?.clickedIncident === incident.id;
  const readOnly = labelVideoStore?.isReadOnly ?? false;
  const canEditing =
    !readOnly && (labelVideoStore?.currentFrame || 0) >= incident.startFrame;
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  // HANDLERS //////////

  const handleEdit = () => {
    if (readOnly) return;
    labelVideoStore?.setClickedIncident(
      labelVideoStore?.clickedIncident === incident.id
        ? null
        : incident.id
    );
  }

  const handleFinish = (e: any) => {
    if (readOnly) return;
    e.stopPropagation();
    labelVideoStore?.setIncidents(
      labelVideoStore?.incidents.map((inc) => {
        if (inc.id === incident.id) {
          return {
            ...inc,
            endTime: labelVideoStore?.currentTime,
            endFrame: labelVideoStore?.currentFrame,
            isFinished: true,
          };
        }
        return inc;
      })
    );
    onFinish();
  }

  const handleChangeType = (e: any) => {
    if (readOnly) return;
    e.stopPropagation();
    labelVideoStore?.setIncidents(
      labelVideoStore?.incidents.map((inc) => {
        if (inc.id === incident.id) {
          return {
            ...inc,
            class: labelVideoStore?.incidentClasses.find(
              (c) => String(c.id) === String(e.target.value)
            ),
          };
        }
        return inc;
      })
    );
  }

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = () => {
    labelVideoStore?.setIncidents(
      labelVideoStore?.incidents.filter((i) => i.id !== incident.id) ?? []
    );
    setDeleteDialogOpen(false);
  };

  //////////////////////
  return (
    <>
    <IncidentItemContainer
      selected={selected}
      onClick={handleEdit}
    >
      {/* ICON */}
      {/* <div style={{
        width: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
        <IconIncident incident={incident} style={{ fontSize: "24px" }} />
      </div> */}
      <div style={{ width: "2px", height: "25px", backgroundColor: color, marginRight: "5px", marginTop: "5px" }} />
      {/* CONTENT */}
      <div>
        {/* LABEL */}
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", marginBottom: "15px" }}>
          {/* <b>{incident.label}:</b> */}
          {readOnly ? (
            // <b>{incident.label}</b>
            <span style={{ marginLeft: "5px", marginTop: "8px", fontWeight: "bold" }}>{incident.label}</span>
          ) : (
            <Select
              style={{ marginLeft: "5px", fontWeight: "bold" }}
              native
              value={incident.class?.id ?? ""}
              onChange={handleChangeType}
            >
              {labelVideoStore?.incidentClasses.map((c) => (
                <option key={c.name} value={c.id}>
                  {c.name}
                </option>
              ))}
            </Select>
          )}
        </div>

        {/* TIMES */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginTop: "5px",
          }}
        >
          <TimeDisplay label="Début" frame={incident.startFrame} time={incident.startTime} fps={labelVideoStore?.fps || 0} />
          <TimeDisplay label="Fin" frame={incident.endFrame} time={incident.endTime} fps={labelVideoStore?.fps || 0} />
        </div>
      </div>

      {/* ACTIONS */}
      {!readOnly && (
      <div
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "start",
            flexGrow: 1
          }}
        >
          <div style={{ display: "flex", flexDirection: "row", gap: "3px" }}>
            {!incident.endTime && (
              <Tooltip title="Définir la fin">
                <span>
                  <IconButton
                    style={{
                      padding: "5px",
                      color: canEditing ? "green" : "gray"
                    }}
                    onClick={handleFinish}
                  >
                    <Done />
                  </IconButton>
                </span>
              </Tooltip>
            )}
            <Tooltip title="Supprimer">
              <IconButton
                style={{
                  padding: "5px",
                }}
                onClick={handleDeleteClick}
              >
                <Delete />
              </IconButton>
            </Tooltip>
          </div>
        </div>
      )}
    </IncidentItemContainer>
    <AlertDialog
      open={deleteDialogOpen}
      onClose={() => setDeleteDialogOpen(false)}
      onAccept={handleConfirmDelete}
      title="Supprimer le label"
      text="Êtes-vous sûr de vouloir supprimer ce label ?"
      acceptLabel="Supprimer"
    />
    </>
  );
};

interface ContainerProps {
  selected?: boolean;
}
const IncidentItemContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  border: ${(props: ContainerProps) => (props.selected ? '1px solid #1976d2' : 'none')};
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 5px;
  background-color: ${(props: ContainerProps) => (props.selected ? 'rgb(25 118 210 / 5%)' : 'white')}; // #fafafa
  cursor: pointer;

  &:hover{
    background-color: ${(props: ContainerProps) => (props.selected ? 'rgb(25 118 210 / 5%)' : '#fbfbfb')};;
  }
`;

export default inject("labelVideoStore")(observer(IncidentItem));
